module.exports = __webpack_public_path__ + "static/arrow_3_lg-715632ff53f77e9d2008d3faf08d00ca.png";